import { createAction } from "@actionCreator";
import { SuccessMessage } from "../constants/actions";

import * as actions from "../constants/actions";
import { actionCreatorsFactory } from "@actionCreator/actionCreatorFactory";

export default actionCreatorsFactory(actions);

export const sendSuccessMessage = createAction(SuccessMessage);
